export default __webpack_public_path__ + "static/media/logo.20e74a64.svg";